'use strict'
import axios from 'axios'
axios.interceptors.request.use(config => {
    // 发送请求  所有的请求都会走这里
    return config
}, error => {
    return Promise.reject(error)
})
axios.interceptors.response.use(response => {
    return response
}, error => {
    return Promise.resolve(error.response)
})
function checkStatus(response, This) {
    // 如果http状态码正常，则直接返回数据
    if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
        return response
    }
    if(navigator.appName == "Microsoft Internet Explorer" && navigator.appVersion .split(";")[1].replace(/[ ]/g,"")=="MSIE9.0") 
    { 
        if(response&&(response.status==undefined)){
            return response;
        }
    } 
    // 异常状态下，把错误信息返回去
    return {
        status: -404,
        msg: '网络异常'
    }
}
// let baseURL= 'http://172.23.101.83/';
let baseURL ='https://supplierinterface.bthhotels.com/';//正式
//let baseURL = 'http://localhost:63678/';//本地
//let baseURL = 'http://172.23.216.57:802/';//测试

// SSO 认证地址
let authURL = 'https://newsso.bthhotels.com/';

function checkCode(res, This) {
    if (res.status === -404) {
      // 请求超时
      //This.$root.logShow("404错误页面上个页面地址：", This.$root.routerPath, false);
      This.$root.logShow("404错误页面信息：", This.$root.$route, false);
      var rurl = This.$root.$route.fullPath;//错误页面，重新加载
      //var backurl = This.$root.routerPath;//错误页面，上个页面地址
      This.$root.isLoading = false
      This.$router.push({ path: '/err', query: { rurl: rurl} })
         return
    }
    // token 过期  或则错误
    else if (res.data.Code == 99) {
      if (This.getCookie('secret') == '' && This.$route.query.localLogin != 1 && This.$route.path != "/auth/callback") {
        This.$root.routerPath = This.$route.fullPath;
        redirectSsoAuthorizeUrl(This);
      } else if (This.getCookie('secret') != '' && This.$route.query.autoLogin != 1) {
        This.$root.routerPath = This.$route.path;
        This.$router.push({ path: '/login', query: { autoLogin: 1 } });
      }
    }
    return res;
}

function redirectSsoAuthorizeUrl(This) {
  let routerPath = This.$root.routerPath.toLowerCase();
  sessionStorage.setItem('originalPath', (routerPath.indexOf('/login') != 0 && routerPath.indexOf('/auth/callback') != 0) ? This.$root.routerPath : '/Home');
  let redirectUrl = encodeURIComponent(window.location.origin + '/auth/callback');
  let url = '{0}connect/authorize?client_id={1}&scope=sso-api&response_type=code&redirect_uri={2}'
    .replace('{0}', authURL).replace('{1}', '20000086').replace('{2}', redirectUrl);
  window.location.href = url;
}

export default {
  post(url, data, This) {
    if (navigator.appName == "Microsoft Internet Explorer" && navigator.appVersion.split(";")[1].replace(/[ ]/g, "") == "MSIE9.0") {
      url = url + "?token=" + This.getCookie('token') + "&curTime=" + new Date().getTime()
    } else {
      url = url + "?curTime=" + new Date().getTime();
    }
    let time1 = new Date().getFullYear() + "-" + new Date().getMonth() + "-" + new Date().getDate() + " " + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds() + ':' + new Date().getMilliseconds();

    return axios({
      method: 'post',
      baseURL: baseURL,
      url: url,
      data,
      timeout: 300000,
      contentType: 'application/json',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'token': This.getCookie('token')
      }
    }).then(
      (response) => {
        try {
          let time2 = new Date().getFullYear() + "-" + new Date().getMonth() + "-" + new Date().getDate() + " " + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds() + ':' + new Date().getMilliseconds();
          console.log({ method: 'post', url: url, req: data, res: response.data, reqtime: time1, restime: time2 });
        }
        catch (err) { console.log(err); }
        return checkStatus(response, This)
      }
    ).then(
      (res) => {
        return checkCode(res, This)
      }
    )
  },
  get(url, params, This) {
    if (navigator.appName == "Microsoft Internet Explorer" && navigator.appVersion.split(";")[1].replace(/[ ]/g, "") == "MSIE9.0") {
      url = url + "?token=" + This.getCookie('token') + "&curTime=" + new Date().getTime()
    } else {
      url = url + "?cutTime=" + new Date().getTime();
    }
    let time1 = new Date().getFullYear() + "-" + new Date().getMonth() + "-" + new Date().getDate() + " " + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds() + ':' + new Date().getMilliseconds();
    return axios({
      method: 'get',
      baseURL: baseURL,
      url: url,
      params,
      // get 请求时带的参数
      timeout: 300000,
      contentType: 'application/json',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'token': This.getCookie('token')
      }
    }).then(
      (response) => {
        try {
          let time2 = new Date().getFullYear() + "-" + new Date().getMonth() + "-" + new Date().getDate() + " " + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds() + ':' + new Date().getMilliseconds();
          console.log({ method: 'get', url: url, req: params, res: response.data, reqtime: time1, restime: time2 });
        }
        catch (err) { console.log(err); }

        return checkStatus(response, This)
      }
    ).then(
      (res) => {
        return checkCode(res, This)
      }
    )
  },
  upload(url, This) {
    url = baseURL + url;
    url = url + "&curTime=" + new Date().getTime() + "&token=" + This.getCookie('token');
    return url;
  },
  redirectSsoAuthorizeUrl(This) {
    redirectSsoAuthorizeUrl(This);
  },
  redirectSsoSignOutUrl(This) {
    let returnUrl = encodeURIComponent(window.location.origin + This.$route.fullPath);
    let url = '{0}AccountLogin/SignOut?returnUrl={1}'.replace('{0}', authURL).replace('{1}', returnUrl);
    window.location.href = url;
  }
}
// https://cashier.bthhotels.com/pages/index.html#/main?code=1520920413_201809201015157769074
// 用法
// async function aaa() {
//     let params = {
//         'code': this.arg
//     }
//     const res = await this.$root.http.post('/mvc/pay/QueryPayInfos', params, this,obj)
// }



// WEBPACK FOOTER //
// ./src/common/js/http.js